import { render, staticRenderFns } from "./FormVendorCandidate.vue?vue&type=template&id=5dbf79a0&scoped=true"
import script from "./FormVendorCandidate.vue?vue&type=script&lang=js"
export * from "./FormVendorCandidate.vue?vue&type=script&lang=js"
import style0 from "./FormVendorCandidate.vue?vue&type=style&index=0&id=5dbf79a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf79a0",
  null
  
)

export default component.exports